import { AxiosResponse } from 'axios';

export interface IProductData {
  id: number;
  name: string;
  type: EProductTypes;
  recommended: boolean;
  prefix?: string;
  normalPrice?: IPrice;
  discountedPriceWithoutApplyingCoupon?: IPrice;
  discount?: IPrice;
  discountPercentage?: number;
  discountedPrice?: IPrice;
  coupon: null | ICoupon;
  country?: string;
  subscriptionDetails?: ISubscriptionPeriod;
  // BW-5247: newly added properties for chargebee implementation: prefix, country
  // BW-6871: new optional property for group packages: maxGroupUsers
  maxGroupUsers?: number;
}

export interface IPrice {
  amount: number;
  currency: string;
}

export interface ISubscriptionPeriod {
  periodType: 'day' | 'month' | 'year';
  periodValue: number;
  trialPeriodDays: number;
}

export interface ICoupon {
  code: string;
  discount: IPrice;
  discountPercentage: number;
}

export type CurrencyDisplayOption = 'code' | 'name' | 'symbol';

export enum EProductTypes {
  ONE_TIME_PAYMENT = 1,
  BUNDLE,
  SUBSCRIPTION,
  GROUP_ONE_TIME,
  GROUP_SUBSCRIPTION,
}

export interface IProductsPayload {
  products: IProductData[];
}

export type TProductApiResponse = AxiosResponse<IProductsPayload>;
